import React, {useState} from 'react';
import styles from './Controller.module.css';
import SelectorBar from "../selector-bar/SelectorBar";
import PreparednessButton from "../preparedness-button/PreparednessButton";
import {PrepState} from "../../models/prep-state.interface";
import {greenDark, greenLight, greenMid} from "../../data/colours";
import ChartContainer from "../chart-container/ChartContainer";

export const initialPrepState: PrepState = {
  underprepared: true,
  progressing: true,
  prepared: true,
};

const prepColours = [greenDark, greenMid, greenLight];

const Controller = () => {
  const [chartTypeState, setChartTypeState] = useState<"cluster" | "bar">("cluster");
  const [dataTypeState, setDataTypeState] = useState<"region" | "sector" | "revenue">("region");
  const [prepState, setPrepState] = useState<PrepState>(initialPrepState);

  const handleChartTypeClick = (type: "cluster" | "bar") => {
    setChartTypeState(() => type);
  };

  const handleDataTypeClick = (type: "region" | "sector" | "revenue") => {
    setDataTypeState(() => type);
  };

  const isAllPrepOff = (prepState: PrepState) => {
      return Object.values(prepState).every((bool) => !bool);
  }

  const handlePrepTypeClick = (prep: "underprepared" | "progressing" | "prepared") => {
    setPrepState((oldState) => {
      const newState = {...oldState}
      newState[prep] = !oldState[prep];
      if (isAllPrepOff(newState)) {
          return {...initialPrepState};
      }
      return newState;
    })
  };

  return (
    <div data-testid="controller">
      <SelectorBar
        chartTypeCB={handleChartTypeClick}
        chartType={chartTypeState}
        dataTypeCB={handleDataTypeClick}
        dataType={dataTypeState}
      />
      <div className={styles.chartArea}>
        <ChartContainer dataType={dataTypeState} prep={prepState} chartType={chartTypeState}/>
      </div>
      <div className={styles.prepButtons}>
        {Object.entries(prepState).map(([text, on], i) =>
          <PreparednessButton
            text={text}
            on={on}
            callback={handlePrepTypeClick}
            color={prepColours[i]} key={i}
          />
        )}
      </div>
    </div>
  );
}

export default Controller;
